var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopPlayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 55,
    viewBox: "0 0 30 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6343 45.8994H1.16152L0.000244141 50.5543L1.16152 54.221H28.6343L29.7929 50.5543L28.6343 45.8994Z",
    fill: "url(#paint0_linear_4539_212400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.119 47.7317H14.8972H2.78628L1.16211 54.2226H14.8972H28.6349L27.119 47.7317Z",
    fill: "url(#paint1_linear_4539_212400)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.119 47.722H14.8972H2.78628L1.16211 45.8994H14.8972H28.6349L27.119 47.722Z",
    fill: "url(#paint2_linear_4539_212400)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1492 49.5168H9.64626C9.64626 49.9732 9.0372 50.3458 8.28467 50.3458V51.5716C9.03449 51.5716 9.64626 51.9415 9.64626 52.3978H20.1492C20.1492 51.9415 20.7583 51.5716 21.5081 51.5716V50.3458C20.7583 50.3458 20.1492 49.9759 20.1492 49.5168Z",
    fill: "url(#paint3_linear_4539_212400)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3509 50.0905C20.8637 50.0905 20.4657 49.8502 20.4657 49.5532V49.2832H9.32935V49.5532C9.32935 49.8502 8.93143 50.0905 8.44418 50.0905H8.00024V51.824H8.44418C8.93143 51.824 9.32935 52.0643 9.32935 52.3613V52.6313H20.4657V52.3613C20.4657 52.0643 20.8637 51.824 21.3509 51.824H21.7948V50.0905H21.3509ZM21.5106 51.5702C20.7608 51.5702 20.1517 51.9401 20.1517 52.3964H9.64877C9.64877 51.9401 9.03971 51.5702 8.28718 51.5702V50.3443C9.037 50.3443 9.64877 49.9744 9.64877 49.5154H20.1517C20.1517 49.9717 20.7608 50.3443 21.5106 50.3443V51.5702Z",
    fill: "url(#paint4_linear_4539_212400)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M6.04667 23.621L11.7529 21.0424L10.4698 7.92554L0.575928 9.15946L12.0074 44.3089L12.2293 44.2792L6.04667 23.621Z",
    fill: "url(#paint5_linear_4539_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M19.32 7.92554L18.0396 21.0424L23.7458 23.621L16.9216 46.4176H17.103L29.2139 9.15946L19.32 7.92554Z",
    fill: "url(#paint6_linear_4539_212400)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M19.3196 7.92495L14.8965 0.22168V19.6243L18.0392 21.0418L19.3196 7.92495Z",
    fill: "url(#paint7_linear_4539_212400)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8966 19.624V46.4167L13.1127 47.2213L6.04761 23.6201L14.8966 19.624Z",
    fill: "url(#paint8_linear_4539_212400)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M6.04666 23.6212L9.07303 22.255L7.7358 15.1565L0.575928 9.15967L12.6354 46.2585L12.8709 46.4178L6.04666 23.6212Z",
    fill: "url(#paint9_linear_4539_212400)",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "difference"
    },
    d: "M10.4702 7.92495L11.7533 21.0418L14.8961 19.6243V0.22168L10.4702 7.92495Z",
    fill: "url(#paint10_linear_4539_212400)"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8965 19.624V46.4167L16.6804 47.2213L23.7455 23.6201L14.8965 19.624Z",
    fill: "url(#paint11_linear_4539_212400)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9893 8.22213L14.8964 1.09937L10.8035 8.22213L1.65405 9.36425L8.27524 14.9102L6.71063 22.7404L14.8964 19.0413L23.0795 22.7404L21.5176 14.9102L28.1388 9.36425L18.9893 8.22213Z",
    fill: "url(#paint12_linear_4539_212400)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8956 1.1019V0.22168L10.4697 7.92495L10.8027 8.22466L14.8956 1.1019Z",
    fill: "url(#paint13_linear_4539_212400)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9877 8.22466L19.3179 7.92495L14.8948 0.22168V1.1019L18.9877 8.22466Z",
    fill: "url(#paint14_linear_4539_212400)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5164 14.912L22.055 15.155L29.2122 9.1582L28.1375 9.36611L21.5164 14.912Z",
    fill: "url(#paint15_linear_4539_212400)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1382 9.36688L29.2129 9.15898L19.319 7.92505L18.9888 8.22476L28.1382 9.36688Z",
    fill: "url(#paint16_linear_4539_212400)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27469 14.9126L7.73601 15.1556L6.04688 23.6203L6.71008 22.7428L8.27469 14.9126Z",
    fill: "url(#paint17_linear_4539_212400)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5164 14.9126L23.0783 22.7428L23.7442 23.6203L22.055 15.1556L21.5164 14.9126Z",
    fill: "url(#paint18_linear_4539_212400)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8948 19.0444V19.6249L23.7438 23.621L23.0779 22.7435L14.8948 19.0444Z",
    fill: "url(#paint19_linear_4539_212400)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8028 8.22476L10.4698 7.92505L0.575928 9.15898L1.65329 9.36688L10.8028 8.22476Z",
    fill: "url(#paint20_linear_4539_212400)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71008 22.7435L6.04688 23.621L14.8959 19.6249V19.0444L6.71008 22.7435Z",
    fill: "url(#paint21_linear_4539_212400)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.65329 9.36611L0.575928 9.1582L7.7358 15.155L8.27448 14.912L1.65329 9.36611Z",
    fill: "url(#paint22_linear_4539_212400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4539_212400",
    x1: 14.8966,
    y1: 47.271,
    x2: 14.8966,
    y2: 53.4623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D83D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "#969ADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#7A81D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4E5B9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4539_212400",
    x1: 14.8972,
    y1: 47.4158,
    x2: 14.8972,
    y2: 57.2035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D83D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BABCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B6B8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AAADE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#969ADF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7A81D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17256B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4539_212400",
    x1: 1.16211,
    y1: 46.8093,
    x2: 28.6349,
    y2: 46.8093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4861C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DEDEF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#AAADE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#4861C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4539_212400",
    x1: 14.5648,
    y1: 49.4736,
    x2: 16.5879,
    y2: 58.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EDCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E6FC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ECCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6C4A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AC862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ECCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E6FC88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4539_212400",
    x1: 14.8975,
    y1: 49.1428,
    x2: 14.8975,
    y2: 53.0309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6FC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#EDCE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E6FC88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#ECCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6C4A16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#AC862A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ECCC3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#E6FC88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4539_212400",
    x1: 10.8759,
    y1: 26.1158,
    x2: 2.94992,
    y2: 26.1158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4539_212400",
    x1: 14.009,
    y1: 25.16,
    x2: 27.5356,
    y2: 29.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4539_212400",
    x1: 19.1301,
    y1: 10.6331,
    x2: 14.236,
    y2: 10.6331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4539_212400",
    x1: 15.2404,
    y1: 33.424,
    x2: 4.22583,
    y2: 33.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4539_212400",
    x1: 15.5074,
    y1: 27.7874,
    x2: 2.22175,
    y2: 27.7874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#A8A9B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#AEB1C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B7BEDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#C2CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4539_212400",
    x1: 14.8122,
    y1: 0.22168,
    x2: 8.95703,
    y2: 0.22168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2CEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4539_212400",
    x1: 29.2785,
    y1: 0.221386,
    x2: 19.5606,
    y2: 0.221386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4539_212400",
    x1: 14.2468,
    y1: 5.19266,
    x2: 17.3982,
    y2: 25.5158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E4FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#C4F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#AAF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8EECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4539_212400",
    x1: 14.4516,
    y1: 1.62841,
    x2: 10.7379,
    y2: 7.6688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4539_212400",
    x1: 19.0554,
    y1: 7.54964,
    x2: 15.4142,
    y2: 1.79283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4539_212400",
    x1: 22.0469,
    y1: 14.588,
    x2: 29.1123,
    y2: 9.16513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4539_212400",
    x1: 27.4182,
    y1: 9.19138,
    x2: 19.5771,
    y2: 8.00556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4539_212400",
    x1: 7.15943,
    y1: 15.3959,
    x2: 7.15943,
    y2: 22.8319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4539_212400",
    x1: 23.6088,
    y1: 23.4853,
    x2: 21.6504,
    y2: 14.9131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4539_212400",
    x1: 15.0518,
    y1: 19.5574,
    x2: 23.6696,
    y2: 23.1614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4539_212400",
    x1: 9.87429,
    y1: 8.21666,
    x2: 2.33051,
    y2: 9.07146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4539_212400",
    x1: 6.93475,
    y1: 21.3341,
    x2: 14.6035,
    y2: 21.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4539_212400",
    x1: 2.38146,
    y1: 10.3894,
    x2: 7.93299,
    y2: 14.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274DE1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.2746 8.68713) scale(6.01213 5.99684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.25817 12.692) rotate(44.927) scale(10.8735 0.652408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.06088 4.4771) rotate(135.073) scale(10.8708 0.652246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.37421 32.2008) scale(6.01213 5.99684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.75351 35.8107) rotate(44.927) scale(10.8735 0.652408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.76321 27.5938) rotate(135.073) scale(10.8708 0.652246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.7539 33.4857) scale(6.01213 5.99684)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1329 37.098) rotate(44.927) scale(10.8735 0.652408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_4539_212400",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.1426 28.8811) rotate(135.073) scale(10.8708 0.652246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05078E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#040682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#020453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01022F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#000115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#000005"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPlayers);
export default __webpack_public_path__ + "static/media/top-players.b23ef8fb869671278a0e24d231ebe3ca.svg";
export { ForwardRef as ReactComponent };